import {ApiConfigPort} from '../config/api-config-port';
import {HttpService} from '../../services/http-service';
import {CreateResult, ListResult} from './lib-rest';

export class CertificateApi {
  config: ApiConfigPort;


 public constructor(config: ApiConfigPort) {
    this.config = config;
  }

 public  async create(registryId: string, panonId: string): Promise<CreateResult>  {
const url =  new URL('/certificate/' + registryId + '/' + panonId + '', this.config.host);

return (await HttpService.getAxiosClient().post(url.toString())).data
  }

 public  async list(registryId: string, panonId: string): Promise<ListResult<CertificateController$CertificateListItem> >  {
const url =  new URL('/certificate/' + registryId + '/' + panonId + '', this.config.host);

return (await HttpService.getAxiosClient().get(url.toString())).data
  }

 public  async view(certificateId: string): Promise<any>  {
const url =  new URL('/certificate/' + certificateId + '.pdf', this.config.host);

return (await HttpService.getAxiosClient().get(url.toString())).data
  }

}

export interface CertificateController$CertificateListItem {
  creationDate: any;
  documentUrl: string;
}

